import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../hooks/useAuth'

interface SuperAdminRouteProps {
  children: React.ReactNode
}

const SuperAdminRoute = ({
  children,
}: SuperAdminRouteProps): JSX.Element | null => {
  const { isBoappaSuperadmin } = useAuth()
  const navigate = useNavigate()

  if (!isBoappaSuperadmin) {
    navigate('/')
    return null
  }

  return <>{children}</>
}

SuperAdminRoute.displayName = 'SuperAdminRoute'
export { SuperAdminRoute }
